import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import Fab from '@material-ui/core/Fab';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';
import CircularProgress from '@material-ui/core/CircularProgress';

import AbsencesTable from '../parts/Absences/AbsencesTable';
import AbsencesDialog from '../parts/Absences/AbsencesDialog';

const styles = theme => ({
  sectionHeading: {
    color: '#394f5a',
  },
  addNewButton: {
    marginTop: 20,
    marginBottom: 30,
  },
});

const mapStateToProps = state => {
  return {
    selectedPupil: state.selectedPupil,
  };
};

class AbsencesPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isLoaded: false,
      data: [],
      meta: {},
      isDialogOpen: false,
      dialogData: null,
    };

    this.axiosCancel = null;

    this.onDialogClose = this.onDialogClose.bind(this);
    this.onAddNewButtonClick = this.onAddNewButtonClick.bind(this);
    this.onEditEntryClick = this.onEditEntryClick.bind(this);
    this.reloadData = this.reloadData.bind(this);
  }

  componentDidMount() {
    this.reloadData();
  }

  componentWillUnmount() {
    if (this.axiosCancel) {
      this.axiosCancel();
    }
  }

  onDialogClose() {
    this.setState({
      isDialogOpen: false,
      dialogData: null,
    });
  }

  onAddNewButtonClick() {
    this.setState({
      isDialogOpen: true,
      dialogData: null,
    });
  }

  onEditEntryClick(entry) {
    this.setState({
      isDialogOpen: true,
      dialogData: entry,
    });
  }

  reloadData() {
    const {
      selectedPupil,
    } = this.props;

    if (!selectedPupil) {
      return;
    }

    this.setState({
      isLoading: true,
      isLoaded: false,
    });

    return axios
      .get(
        `${window.apiReportAbsenceUrl}/getreportedabsences/${selectedPupil.id}`,
        {
          cancelToken: new axios.CancelToken((c) => { this.axiosCancel = c }),
        }
      )
      .then((response) => {
        if (response.data.success) {
          const data = response.data.data;
          this.setState({
            data: data.absences,
            meta: {
              allowed_file_types: data.allowed_file_types,
              help_text: data.help_text,
              max_files_allowed: data.max_files_allowed,
              max_filesize_allowed: data.max_filesize_allowed,
            },
          });
        }

        this.setState({
          isLoading: false,
          isLoaded: true,
        });
      })
      .catch((thrown) => {});
  }

  render() {
    const {
      isLoaded,
      isLoading,
      data,
      meta,
      isDialogOpen,
      dialogData,
    } = this.state;
    const {
      classes,
      t,
    } = this.props;

    return (
      <div className="absences-page">
        <Typography
          className={classes.sectionHeading}
          variant="h5"
          component="h5"
        >
          {t('Absences')}
        </Typography>
        <div>
          <Fab
            size="small"
            variant="extended"
            color="secondary"
            className={classes.addNewButton}
            onClick={this.onAddNewButtonClick}
          >
            {t('Report new absence')}
          </Fab>
        </div>
        {isLoading && !isLoaded && (
          <CircularProgress />
        )}
        {isLoaded && data.length === 0 && (
          <p>{t('You currently have no reported absences')}</p>
        )}
        {isLoaded && data.length > 0 && (
          <AbsencesTable
            entries={data}
            onEditEntryClick={this.onEditEntryClick}
            reloadData={this.reloadData}
            useSuspense={false}
          />
        )}
        <AbsencesDialog
          isDialogOpen={isDialogOpen}
          onDialogClose={this.onDialogClose}
          reloadData={this.reloadData}
          data={dialogData}
          meta={meta}
          useSuspense={false}
        />
      </div>
    );
  }
}

export default connect(mapStateToProps)(
  withStyles(styles)(withTranslation()(AbsencesPage))
);
